export default __webpack_public_path__ + "static/media/photo--sm--leena-1.932c73f1.jpg";